<template>
  <div>
    <h3>Verify Ownership</h3>

    <div v-if="iff_prefill && iff_prefill.fn">
      <p>Please confirm that the information below is correct.</p>
      <div class="iff-confirm">
        <p style="font-size: 20px; font-weight: bold">
          {{ iff_prefill.fn }} {{ iff_prefill.ln }}
        </p>
        <p style="margin-bottom: 0px">{{ iff_prefill.address }}</p>
        <p>
          {{ iff_prefill.city }}, {{ iff_prefill.state }} {{ iff_prefill.zip }}
        </p>
      </div>
      <div class="buttons is-right">
        <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->

        <a
          class="button is-link padded-button next-button"
          :class="clicked ? 'is-loading' : ''"
          @click="acceptMatch"
          >Confirm</a
        >
        <a class="button is-link is-inverted decline-button" @click="next"
          >This is not my information.</a
        >
      </div>
    </div>
    <div v-else>
      <p class="eligibility_label">
        Check the eligibility of <b>{{ company_name }}</b> in 60 seconds
      </p>

      <Input
        v-if="!removeTid"
        @enter="next"
        :inputField="inputs.tid"
        inputName="Business Federal Tax ID (EIN)"
        placeholder="XX-XXXXXXX"
        inputType="ein"
        obj="business"
      />

      <Dropdown
        :inputField="inputs.srfico"
        :options="ficoOptions"
        inputName="Your Estimated Credit Score"
        inputType="string"
      />
      <div
        style="
          background: #f6f6f6;
          padding: 20px;
          border-radius: 5px;
          margin-bottom: 20px;
        "
      >
        <!-- <p style="font-variant-caps: all-petite-caps; font-size: 0.8rem;">We use encryption to protect your personal information.</p> -->

        <p
          style="
            color: #363636;
            display: block;
            font-size: 1rem;
            font-weight: 500;
            margin-bottom: 5px;
          "
        >
          Last 4 Digits of SSN
        </p>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              flex-shrink: 1;
              padding: 5px;
              margin-top: 12px;
              margin-right: 5px;
              text-align: justify;
            "
          >
            XXX-XX-
          </div>
          <div style="flex: 1">
            <Input
              @enter="next"
              :inputField="inputs.ssn"
              inputName=""
              placeholder="XXXX"
              inputType="last4"
              :icons="{ right: 'fa-lock' }"
            />
          </div>
        </div>
        <Input
          @enter="next"
          :inputField="inputs.zip"
          inputName="Home Zip Code"
          inputType="zip"
          ref="zip"
        />
      </div>
      <Checkbox
        :inputField="inputs.consent"
        inputName="IFF Consent"
        inputType="required"
      >
        You understand that by clicking <strong>"Continue"</strong> immediately
        below you are authorizing Experian to disclose your personally
        identifiable information or other information to Cardiff on your behalf
        solely to prefill your application.
      </Checkbox>

      <input type="hidden" id="atadlauqID" name="atadlauqID" />

      <div class="buttons is-right">
        <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
        <a
          class="button is-link padded-button next-button"
          :class="clicked ? 'is-loading' : ''"
          @click="sendFNRequest"
          >Continue</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import AddressInput from "@/components/shared/AddressInput";
import Dropdown from "@/components/shared/Dropdown";
import Checkbox from "@/components/shared/Checkbox";
import ApplyPage from "@/components/shared/ApplyPage";
import moment from "moment";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "IFF",
  components: {
    Input,
    Checkbox,
    Dropdown,
  },
  props: {
    removeTid: Boolean,
    api: String,
    link: String,
  },
  mixins: [ApplyPage],
  mounted: function () {
    console.log("mounted iff");
    let company_name = getWithExpiry("company_name");
    if (company_name && company_name !== "") {
      this.company_name = company_name;
    }

    //writes to the hidden input
    atadlauq.atadlauqc("atadlauqID");
  },
  methods: {
    sendFNRequest: function () {
      let self = this;
      // this.validate()
      const jsc = document.getElementById("atadlauqID").value;
      const hdm = document.getElementById("user_prefs2").value;
      console.log("got jsc", jsc);
      console.log("got hdm", hdm);

      // self.next()
      self.clicked = true;
      if (!self.validateInPlace()) {
        console.log("not sending any request until this is valid");
        self.clicked = false;
        return;
      }
      $.ajax({
        type: "POST",
        url: "/api/" + self.api + "/iff-match",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          jsc: jsc,
          hdm: hdm,
          last4: self.inputs.ssn.value,
          zip: self.inputs.zip.value,
          link: self.link,
        }),
      })
        .done(function (resp) {
          console.log("iff matched", resp);

          let m = moment(resp.model.dob);
          resp.model.dob = m.format("YYYY-MM-DD");

          self.iff_prefill = resp.model;
          self.clicked = false;
          // self.next()
        })
        .fail(function (err) {
          console.log(JSON.stringify(err));
          self.clicked = false;
          // alert(err)
          self.next();
        });

      console.log("moving on");
    },
    acceptMatch: function () {
      let self = this;
      if (self.clicked) {
        return;
      }
      self.clicked = true;
      console.log(
        "accepting - send page 4 style request and move forward 2 pages"
      );
      self.next();
    },
  },
  data() {
    return {
      obj: "pg",
      clicked: false,
      iff_prefill: null,
      ficoOptions: [
        "Less than 525",
        "550",
        "575",
        "600",
        "625",
        "650",
        "675",
        "700+",
      ],
      inputs: {
        tid: Input.model(),
        srfico: Input.model(),
        ssn: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        dob: Input.model(),
        consent: Input.model(),
      },
      company_name: "",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.decline-button {
  padding: 5px !important;
  margin-top: 20px;
  width: 100%;
}

.iff-confirm {
  width: 100%;
  margin: 20px 0px;
  background: #efefef;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}
.eligibility_label {
  font-weight: 500;
}
</style>
